export const getListRoutes = (paths) =>
  Object.values(paths)
    .map((path) => (typeof path === 'string' ? path : getListRoutes(path)))
    .flat();
